import { Injectable } from '@angular/core';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

@Injectable({
  providedIn: 'root'
})
export class OrganizationDataService {
  async fetchTabAssets(orgUid: string, tabName: string, canManage: boolean) {
    const currentTabCollection = tabName.toLowerCase();
    const colRef = collection(db, 'accounts', orgUid, currentTabCollection);
    
    // Non-managers only see published assets
    const q = canManage
      ? query(colRef)
      : query(colRef, where('status', '==', 'published'));
      
    const snap = await getDocs(q);
    const items = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() } as any));

    items.sort((a, b) => {
      const parseTime = (val: any) => {
        const dateVal = val.createdAt || val.createdAt;
        if (!dateVal) return 0;
        if (typeof dateVal === 'object' && dateVal !== null && 'seconds' in dateVal) {
          return dateVal.seconds;
        }
        if (dateVal instanceof Date) return dateVal.getTime() / 1000;
        return new Date(dateVal).getTime() / 1000;
      };
      return parseTime(b) - parseTime(a);
    });

    return items;
  }
}

